import React from 'react';
import {Modal} from "@tag/tag-components-react-v4";
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import {APPTermination} from "../types/APPTermination";
import { ProjectAccents } from "../../General/config/projectAccents";


function UnlockConfirmationModal(props: { visible: boolean, selectedTermination: APPTermination, handleClose: Function, handleUnlock: Function }) {
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    if (!AppRolesService.canUserLockAppEnvironments(accounts, isAuthenticated)) {
        throw new Error()
    }

    const renderModalContent = () => {
        let modalContent;
        
        modalContent = (
            <>
                Are you sure you wish to restore {props.selectedTermination.customerName}?
            </>
        )

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            heading={'Confirm'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{text: 'Confirm'}}
            onPrimaryButtonClick={() => props.handleUnlock()}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default UnlockConfirmationModal;
